import React from 'react';

import { UserRole } from '@appUtils/tripConverter';
import UserRoleList from '../UserRoleList';

const Owners = () => <UserRoleList role={UserRole.OWNER} withActions />;

export default Owners;
